// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#kpi1[data-v-1d14fb08]{width:70%;height:95%;box-sizing:border-box}#kpi1[data-v-1d14fb08],#kpi1 .box[data-v-1d14fb08]{position:relative}#kpi1 .box[data-v-1d14fb08]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
